import type { AxiosError, InternalAxiosRequestConfig } from 'axios';
import qs from 'qs';
import { isDevEnv } from '@/config/utils';

export function logResponseErrorInterceptor(e: AxiosError) {
  if (!isDevEnv()) return;

  const locationString = [
    e.config?.url,
    '',
    '',
    e.request?.data,
    '',
  ].filter(Boolean).join('\n');

  console.error(
    `%cerror %c${e.response?.status} %c${e.response?.statusText}\n\n${locationString}`,
    'color: #646464',
    'color: #5fafff',
    'color: #ffffff',
  );
}

export function logRequestInterceptor(config: InternalAxiosRequestConfig) {
  if (!isDevEnv()) return config;

  const pic = {
    patch: '◆',
    post: '◆',
    put: '◆',
    get: '■︎',
    delete: '✕',
  }[config.method];
  const method = config.method.toUpperCase().concat(' '.repeat(7 - config.method.length));
  const q = config.params ? `?${qs.stringify(config.params)}` : '';

  console.info(
    `%c${' '.repeat(8)}[chat-api] ${method} %c${pic} ${config.url}${q}`,
    'color: #646464; font-weight: bold;',
    'color: #646464;',
  );

  return config;
}